//
//
//
//
//
//
//
//

	export default{
		data(){
			return{

			}
		},
        mounted(){

        },
		methods:{

		},
		props: {
			data: {
				type: Object
			},
			submitFn: {

			}
		}
	}




// WEBPACK FOOTER //
// ./src/components/TipBox.vue